export default __webpack_public_path__ + "static/media/bboxx.f0b64778.jpg";